$(document).on('turbolinks:load', function() {
  $(function() {
    Foundation.addToJquery($);
    $(document).foundation();
  });
});